import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { CallProcess } from '../../models/graphics/call-process';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/forkJoin';
import { environment } from 'src/environments/environment';
import { CommonFilter, GeneralFilter, NETTESTTYPES, MOBILEINFOTYPES } from 'src/app/shared/models/Common/common-filter';
import { CommonFilterService } from '../common-filter/common-filter.service';
import { formatDate, lastDateFunc, formatDBTZDateToLocalDate } from 'lib/common/utils';
import { DemoService } from '../../demo.service';
import { DatePipe } from '@angular/common';
import { DataFilter } from 'lib/ng-data-table/base';

@Injectable({
  providedIn: 'root'
})
export class CallProcessService {

  apiUrl = environment.urlAddress;
  private commonFilter: CommonFilter;
  private generalFilterArray: Array<GeneralFilter>;
  private dataFilter: DataFilter;

  constructor(private http: HttpClient, private service: DemoService, private commonFilterService: CommonFilterService, public datepipe: DatePipe) {
    this.commonFilter = new CommonFilter();
    this.generalFilterArray = [];
    this.dataFilter = new DataFilter();
  }

  async getCallProcessesList(delFilterColName, AllGeneralFilter, filtersWithEventID, filters, TimestampType, columnName) {
    
    //let params = new HttpParams()
    //  .set('TSType', TSType)
    //  .set('TSBetween', TSBetween);
    this.generalFilterArray = [];
    this.commonFilter.TimestampType = TimestampType;

    let dbTz = -500;
    //this.commonFilterService.DB_TZ.subscribe(res => {
    //  dbTz = res;
    //});
    //if (dbTz == -500) {//query var col table
    //  await this.service.getDBTimezoneDiff('VquadData').then(res => {
    //    this.commonFilterService.setDBTZFromVarCol(res);
    //    dbTz = res;
    //  });
    //}
    ////console.log(dbTz)

    let MainFilterTZ = 0;
    this.commonFilterService.mainFilterID.subscribe(res => this.commonFilter.MainFilterID = res);// set mainfilter ID
    this.commonFilterService.mfTZ.subscribe(res => MainFilterTZ = res);
    //console.log(this.commonFilter.MainFilterID)

    let dbAndBrHrs = -500;
    //if (this.commonFilter.MainFilterID != 0) {
      this.commonFilterService.DB_BRDiff.subscribe(res => {
        dbAndBrHrs = res;
      });
      if (dbAndBrHrs == -500) {//query var col table
        await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
          this.commonFilterService.setDBAndBrowserHrsDiff(res);
          dbAndBrHrs = res;
        });
      }
    //}
    let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000), dbTz, dbAndBrHrs) + "^" + formatDate(new Date(), dbTz, dbAndBrHrs);//"06/02/2019 11:00:00^06/02/2019 20:00:00";  

    this.commonFilterService.TSBetween.subscribe(res => dates = res);//latest dates selected is set here from service
    //Added to set proper dates here based on range selection
    this.commonFilterService.TSRangeFilter.subscribe(res => { if (res.RangeType !== "custom") { dates = lastDateFunc(res.RangeType, dbTz, dbAndBrHrs) } });//sets start and end dates to latest timestamps based on range type selection - IMP
    //Save current date selection in service to affected when switched to other screens from here - IMP
    this.commonFilterService.setDatesProperties(dates);

    //(dates.split('^'))[0], columnName, FilterOperator.IN_RANGE, (dates.split('^'))[1], DataType.Date, rsltType, columnTitle
    this.generalFilterArray.push({ ColumnName: columnName, Operator: 6, Value: (dates.split('^'))[0], ValueTo: (dates.split('^'))[1],LoggedInUserName:null });
    this.generalFilterArray.push({ ColumnName: columnName, Operator: 13, Value: null, ValueTo: null,LoggedInUserName:null });
    //console.log(this.generalFilterArray)
    let genArr = [];
    let genArrCnt = 0;


    //https://debugmode.net/2019/10/24/when-to-use-the-subscribe-method-or-async-pipe-in-angular/ - IMP
    //[{
    //  "ColumnName": "VQuad_CallID",
    //    "Operator": 10,
    //      "Value": "fx",
    //        "ValueTo": null,
    //          "LoggedInUserName": "admin",
    //            "RsltType": "",
    //              "MainFilterName": ""
    //}]
    if (delFilterColName != 'clearAllFilters') {
      genArr = AllGeneralFilter.filter(el => {
        return el["ColumnName"].toUpperCase() != columnName.toUpperCase() && (el["RsltType"] == 'call-events' || el["RsltType"] == '');
      });

      this.commonFilterService.GeneralFilterDF.subscribe(res => {
        //console.log(res)
        filters = res;
      });
    }

    //{
    //"value": "fx",
    //  "matchMode": "startsWith",
    //    "valueTo": null,
    //      "type": "string",
    //        "rsltType": "",
    //          "title": "VQuad Event ID"
    //}
    if (typeof filtersWithEventID == 'object' && Object.keys(filtersWithEventID).length > 0) {//https://www.becomebetterprogrammer.com/how-to-check-for-an-empty-object-in-typescript-and-javascript/
      this.dataFilter.filters = filtersWithEventID;
      //console.log(filtersWithEventID)
      genArr = genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });
      let generalFilterArrayAll = this.dataFilter.getProcessedFiltersArray("ALL");
      genArr = [...genArr, ...generalFilterArrayAll];

      for (const key in filters) {
        if (key == 'VQuad_CallID')
          delete filters[key];
      }
      let generalFilterArrayNew = this.dataFilter.getProcessedFilters("");
      filters = { ...filters, ...generalFilterArrayNew };
    }
    //console.log(genArr)
    //console.log(filters)

    if (delFilterColName != '' && delFilterColName != 'clearAllFilters') {
      //cleared = 1;
      genArr = genArr.filter(el => {
        return el["ColumnName"] != delFilterColName;
      });

      for (const key in filters) {
        if (key == delFilterColName)
          delete filters[key];
      }
    }

    //https://stackoverflow.com/questions/38092458/merge-two-object-arrays-with-angular-2-and-typescript
    this.generalFilterArray.push(...genArr);
    genArrCnt = genArr.length;

    if (delFilterColName != 'clearAllFilters') {
      let newFilters = {};
      for (const key in filters) {
        if (filters[key].rsltType == 'call-events' || filters[key].rsltType == '') {
          let value = filters[key].value;
          let matchMode = filters[key].matchMode;
          let valueTo = filters[key].valueTo;
          let type = filters[key].type;
          let rsltType = filters[key].rsltType;
          let title = filters[key].title;
          newFilters[key] = { value, matchMode, valueTo, type, rsltType, title };
        }
      }
      //console.log(newFilters)
      this.commonFilterService.setGeneralFilterData(newFilters);
    }

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };

    this.generalFilterArray.push({ ColumnName: "VQuad_CallID", Operator: 10, Value: 'O', ValueTo: null, LoggedInUserName: null });
    
    //console.log(this.generalFilterArray)
    let body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray });
    const response1 = await this.http.post<any[]>(this.apiUrl + '/api/CallProcessGraphs/GetPlacingCallsData', body, options).toPromise();

    let timeFormat = 'HH:mm:ss';
    let colonCnt = response1[0].VQuadNewTS.split(":").length - 1;
    if (colonCnt == 1)
      timeFormat = 'HH:mm';
    else if (colonCnt == 0)
      timeFormat = 'HH:mm';//'HH'

    let eiphenCnt = response1[0].VQuadNewTS.split("-").length - 1;
    let newResponse1 = response1.map(x => ({
      VQuadNewTS: ((x.VQuadNewTS.indexOf('-') == -1 && x.VQuadNewTS.indexOf(':') == -1) || eiphenCnt == 1) ? x.VQuadNewTS : this.datepipe.transform(new Date(formatDBTZDateToLocalDate(x.VQuadNewTS.replace(/\-/g, '/'), dbTz, dbAndBrHrs, MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat), ID: x.ID, SUCCESS: x.SUCCESS,
      FAILED: x.FAILED
    }));
    //console.log(newResponse1)

    this.generalFilterArray.pop();
    this.generalFilterArray.push({ ColumnName: "VQuad_CallID", Operator: 10, Value: 'I', ValueTo: null, LoggedInUserName: null });
    body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray });
    const response2 = await this.http.post<any[]>(this.apiUrl + '/api/CallProcessGraphs/GetIncomingCallsData', body, options).toPromise();
    timeFormat = 'HH:mm:ss';
    colonCnt = response2[0].VQuadNewTS.split(":").length - 1;
    if (colonCnt == 1)
      timeFormat = 'HH:mm';
    else if (colonCnt == 0)
      timeFormat = 'HH:mm';//'HH'
    eiphenCnt = response2[0].VQuadNewTS.split("-").length - 1;
    let newResponse2 = response2.map(x => ({
      VQuadNewTS: ((x.VQuadNewTS.indexOf('-') == -1 && x.VQuadNewTS.indexOf(':') == -1) || eiphenCnt == 1) ? x.VQuadNewTS : this.datepipe.transform(new Date(formatDBTZDateToLocalDate(x.VQuadNewTS.replace(/\-/g, '/'), dbTz, dbAndBrHrs, MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat), ID: x.ID, SUCCESS: x.SUCCESS,
      FAILED: x.FAILED
    }));

    this.generalFilterArray.pop();
    this.generalFilterArray.push({ ColumnName: "VQuad_CallID", Operator: 10, Value: 'O', ValueTo: null, LoggedInUserName: null });
    body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray });
    const response3 = await this.http.post<any[]>(this.apiUrl + '/api/CallProcessGraphs/GetPlacingCallsDurationData', body, options).toPromise();
    //console.log(response3)
    timeFormat = 'HH:mm:ss';
    colonCnt = response3[0].VQuadNewTS.split(":").length - 1;
    if (colonCnt == 1)
      timeFormat = 'HH:mm';
    else if (colonCnt == 0)
      timeFormat = 'HH:mm';//'HH'
    eiphenCnt = response3[0].VQuadNewTS.split("-").length - 1;
    let newResponse3 = response3.map(x => ({
      VQuadNewTS: ((x.VQuadNewTS.indexOf('-') == -1 && x.VQuadNewTS.indexOf(':') == -1) || eiphenCnt == 1) ? x.VQuadNewTS : this.datepipe.transform(new Date(formatDBTZDateToLocalDate(x.VQuadNewTS.replace(/\-/g, '/'), dbTz, dbAndBrHrs, MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat), ID: x.ID, ThirtySec: x.ThirtySec,
      TwoMin: x.TwoMin, TenMin: x.TenMin, ThirtyMin: x.ThirtyMin, MoreThirtyMin: x.MoreThirtyMin
    }));

    this.generalFilterArray.pop();
    this.generalFilterArray.push({ ColumnName: "VQuad_CallID", Operator: 10, Value: 'I', ValueTo: null, LoggedInUserName: null });
    body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray });
    const response4 = await this.http.post<any[]>(this.apiUrl + '/api/CallProcessGraphs/GetIncomingCallsDurationData', body, options).toPromise();
    timeFormat = 'HH:mm:ss';
    colonCnt = response4[0].VQuadNewTS.split(":").length - 1;
    if (colonCnt == 1)
      timeFormat = 'HH:mm';
    else if (colonCnt == 0)
      timeFormat = 'HH:mm';//'HH'
    eiphenCnt = response4[0].VQuadNewTS.split("-").length - 1;
    let newResponse4 = response4.map(x => ({
      VQuadNewTS: ((x.VQuadNewTS.indexOf('-') == -1 && x.VQuadNewTS.indexOf(':') == -1) || eiphenCnt == 1) ? x.VQuadNewTS : this.datepipe.transform(new Date(formatDBTZDateToLocalDate(x.VQuadNewTS.replace(/\-/g, '/'), dbTz, dbAndBrHrs, MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat), ID: x.ID, ThirtySec: x.ThirtySec,
      TwoMin: x.TwoMin, TenMin: x.TenMin, ThirtyMin: x.ThirtyMin, MoreThirtyMin: x.MoreThirtyMin
    }));

    this.generalFilterArray.pop();
    body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray });
    const response5 = await this.http.post<any[]>(this.apiUrl + '/api/CallProcessGraphs/GetErrorEventsData', body, options).toPromise();
    //console.log(response5)
    timeFormat = 'HH:mm:ss';
    colonCnt = response5[0].VQuadNewTS.split(":").length - 1;
    if (colonCnt == 1)
      timeFormat = 'HH:mm';
    else if (colonCnt == 0)
      timeFormat = 'HH:mm';//'HH'
    eiphenCnt = response5[0].VQuadNewTS.split("-").length - 1;
    let newResponse5 = response5.map(x => ({
      VQuadNewTS: ((x.VQuadNewTS.indexOf('-') == -1 && x.VQuadNewTS.indexOf(':') == -1) || eiphenCnt == 1) ? x.VQuadNewTS : this.datepipe.transform(new Date(formatDBTZDateToLocalDate(x.VQuadNewTS.replace(/\-/g, '/'), dbTz, dbAndBrHrs, MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat), ID: x.ID, ERRORSCOUNT: x.ERRORSCOUNT
    }));

    //return Observable.forkJoin([response1, response2, response3, response4, response5]);
    return await Promise.all([newResponse1, newResponse2, newResponse3, newResponse4, newResponse5, genArrCnt]);
  }
}
